import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-visitortype-related-image',
  templateUrl: './visitortype-related-image.component.html',
  styleUrls: ['./visitortype-related-image.component.scss']
})
export class VisitorTypeRelatedImageComponent extends AbstractWidgetComponent implements OnInit {

  imageUrl: string;
  
  constructor(
    public translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {
   
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'visitorRoleRelatedImageUrl') {
      this.imageUrl = contextChange.value;
    }
  }

  onSetElementAndContext() {
    this.imageUrl = this.dashboardContext.getContextValue('visitorRoleRelatedImageUrl');
  }

}
